<template>
  <section id="about" class="resume-section">
    <div class="resume-section-content">
      <h1 class="mb-0">
        {{ firstName }}
        <span class="text-primary">{{ lastName }}</span>
      </h1>
      <div class="subheading mb-5">
        {{ city }} ·
        {{ province }} ·
        {{ phone }} ·
        <a href="mailto:yipingche96@gmail.com">yipingche96@gmail.com</a>
      </div>
      <div class="mb-5">
        <p class="lead" v-for="(paragraph, index) in aboutMeContent" :key="index">
          {{ paragraph }}
        </p>
      </div>
      <div class="social-icons">
        <a class="social-icon" href="https://www.linkedin.com/in/yipingche/"><i class="fab fa-linkedin-in"></i></a>
        <a class="social-icon" href="https://github.com/cypecial"><i class="fab fa-github"></i></a>
      </div>
      <div class="mt-5">
        <p class="lead">
          {{ contactMe }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    aboutMeContent() {
      return this.$i18n.messages[this.$i18n.locale].about.content;
    },
    firstName() {
      return this.$t('profile.firstName');
    },
    lastName() {
      return this.$t('profile.lastName');
    },
    city() {
      return this.$t('profile.city');
    },
    province() {
      return this.$t('profile.province');
    },
    phone() {
      return this.$t('profile.phone');
    },
    contactMe() {
      return this.$t('contact.description');
    }
  }
};
</script>
